import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=24a5f37e&scoped=true&"
import script from "./FileInput.vue?vue&type=script&lang=ts&"
export * from "./FileInput.vue?vue&type=script&lang=ts&"
import style0 from "./FileInput.vue?vue&type=style&index=0&id=24a5f37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a5f37e",
  null
  
)

export default component.exports